import ApiClient from './ApiClient';
import axios from 'axios';

class BusinessCardImportsAPI extends ApiClient {
  constructor() {
    super('business_card_imports', { accountScoped: true });
  }

  index({ params = {} }) {
    return axios.get(this.url, { params });
  }

  show({ importId }) {
    return axios.get(`${this.url}/${importId}`);
  }

  create({ fileIds }) {
    return axios.post(this.url, { file_ids: fileIds });
  }

  update({ importId, payload }) {
    return axios.patch(`${this.url}/${importId}`, payload);
  }

  commit({ importId, entryIds, tags = [] }) {
    return axios.post(`${this.url}/${importId}/commit`, {
      entry_ids: entryIds,
      tags,
    });
  }

  destroy({ importId }) {
    return axios.delete(`${this.url}/${importId}`);
  }

  directUploadUrl() {
    return `${this.url}/direct_uploads`;
  }

  get directUploadsUrl() {
    return `${this.url}/direct_uploads`;
  }
}

export default new BusinessCardImportsAPI();
